import { useCallback } from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../common/list/FilterToggleGroup';

const prjTyps = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: 'N', label: '프로젝트', color: 'info' },
  { id: 2, value: 'M', label: '유지보수', color: 'success' },
];

// 타입 필터 - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
const ChanceFailStatusList = ({ filters, onFilters }) => {
  const handleFilterType = useCallback(
    (value) => {
      onFilters('searchPrjTyp', value);
    },
    [onFilters],
  );

  return (
    <FilterToggleRow>
      <FilterToggleGroup label="타입" options={prjTyps} value={filters.searchPrjTyp} onChange={handleFilterType} />
    </FilterToggleRow>
  );
};

export default ChanceFailStatusList;
